import React from 'react';
import classes from './UserInfo.module.css';
var UserInfo = function (_a) {
    var name = _a.name;
    return React.createElement("div", { className: classes.user }, "\u041F\u0440\u0438\u0432\u0435\u0442, ".concat(name));
};
export default UserInfo;
